import React, { useReducer, useEffect, useCallback } from "react";
import useRouter, { RouteProp } from "react-simplest-router";
import reducer from "../store/reducer";
import initialState from "../store/state";
import TitleScreen from "./TitleScreen";
import BattleScreen from "./BattleScreen";
import Selection from "./SelectionScreen";
import TreeScreen from "./TreeScreen";
import { ScreenComponent } from "./types";

const initialRoutes: RouteProp<ScreenComponent>[] = [
  { location: "#title", component: TitleScreen },
  { location: "#battle", component: BattleScreen },
  { location: "#gambit_selection", component: Selection },
  { location: "#tech_tree", component: TreeScreen }
];

export default function Page() {
  const { setRoute, ActiveComponent } = useRouter<ScreenComponent>(
    initialRoutes
  );
  const [state, dispatch] = useReducer(reducer, initialState);

  // we must use callback to avoid useEffect re-rendering each time
  const changeRoute = useCallback(
    (newRoute: string) => {
      setRoute(newRoute);
      document.location.hash = newRoute;
    },
    [setRoute]
  );

  useEffect(() => {
    if (document.location.hash !== state.screen) {
      changeRoute(state.screen);
    }
  }, [state.screen, changeRoute]);

  return (
    <div>
      <ActiveComponent dispatch={dispatch} state={state} />
    </div>
  );
}
